"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalMenu = ModalMenu;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _Modal = require("b2b-components/theme/components/Modal");
var _classnames = _interopRequireDefault(require("classnames"));
var _Menu = require("./Menu");
var _RecursiveMenu = require("./RecursiveMenu");
require("./ModalMenu.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ModalMenu(_ref) {
  var activeLanguage = _ref.activeLanguage,
    brands = _ref.brands,
    catalog = _ref.catalog,
    ownAssortment = _ref.ownAssortment,
    className = _ref.className,
    isLoggedIn = _ref.isLoggedIn,
    languages = _ref.languages,
    links = _ref.links,
    catalogLinks = _ref.catalogLinks,
    onLanguageChange = _ref.onLanguageChange,
    onLogout = _ref.onLogout,
    onModalLinkClick = _ref.onModalLinkClick,
    text = _ref.text,
    companyName = _ref.companyName;
  var Menu = ModalMenu.Menu,
    RecursiveMenu = ModalMenu.RecursiveMenu;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    categoryPath = _useState2[0],
    setCategoryPath = _useState2[1];
  var onOpenModal = (0, _react.useCallback)(function () {
    setCategoryPath([]);
  }, []);
  var openNextLevel = (0, _react.useCallback)(function (previousTitle, children, href, title, id) {
    return function (e) {
      e.preventDefault();
      setCategoryPath([].concat((0, _toConsumableArray2["default"])(categoryPath), [{
        previousTitle: previousTitle,
        children: children,
        href: href,
        title: title,
        id: id
      }]));
    };
  }, [categoryPath]);
  var openPrevLevel = (0, _react.useCallback)(function (e) {
    e.preventDefault();
    setCategoryPath(categoryPath.slice(0, -1));
  }, [categoryPath]);
  var handleLinkClick = (0, _react.useCallback)(function (closeModal) {
    return function (url) {
      return function (e) {
        e.preventDefault();
        onModalLinkClick(url);
        closeModal(e);
      };
    };
  }, [onModalLinkClick]);
  var renderContent = (0, _react.useCallback)(function (closeModal) {
    if (categoryPath.length > 0) {
      var lastCategory = categoryPath.at(-1);
      return /*#__PURE__*/_react["default"].createElement(RecursiveMenu, {
        previousTitle: lastCategory.previousTitle,
        catalogLinks: lastCategory.id === _RecursiveMenu.MENU_CATEGORY_ID.catalog && catalogLinks,
        ownAssortment: lastCategory.id === _RecursiveMenu.MENU_CATEGORY_ID.catalog && ownAssortment,
        href: lastCategory.href,
        title: lastCategory.title,
        openNextLevel: openNextLevel,
        openPrevLevel: openPrevLevel,
        onLinkClick: handleLinkClick(closeModal),
        text: text,
        companyName: companyName
      }, lastCategory.children);
    }
    return /*#__PURE__*/_react["default"].createElement(Menu, {
      activeLanguage: activeLanguage,
      catalog: catalog,
      brands: brands,
      isLoggedIn: isLoggedIn,
      languages: languages,
      links: links,
      onLanguageChange: onLanguageChange,
      onLinkClick: handleLinkClick(closeModal),
      onLogout: onLogout,
      onModalClose: closeModal,
      openNextLevel: openNextLevel,
      text: {
        catalog: text.catalog,
        brands: text.brands,
        home: text.home,
        logout: text.logout
      }
    });
  }, [handleLinkClick, openNextLevel, openPrevLevel, activeLanguage, brands, ownAssortment, catalog, companyName, catalogLinks, isLoggedIn, languages, links, onLanguageChange, onLogout, text, categoryPath, RecursiveMenu, Menu]);
  var rootClassName = (0, _classnames["default"])('cds-Header-ModalMenuModal', className);
  return /*#__PURE__*/_react["default"].createElement(_Modal.Modal, {
    text: {
      ariaLabel: text.ariaLabelMobile,
      ariaCloseModal: text.ariaCloseModalMobile
    },
    className: rootClassName,
    closeButton: _Modal.MODAL_CLOSE_BUTTON.left,
    animationType: _Modal.MODAL_ANIMATION_TYPE.slideLeft,
    triggerObject: /*#__PURE__*/_react["default"].createElement(_ButtonIcon.ButtonIcon, {
      className: "cds-Header-MenuButton",
      styleType: _ButtonIcon.BUTTON_ICON_STYLE_TYPE.ghost,
      size: _ButtonIcon.BUTTON_ICON_SIZE.small,
      icon: _ButtonIcon.BUTTON_ICON_ICON_NAME.menu
    }),
    onOpenModal: onOpenModal,
    type: _Modal.MODAL_TYPE.fullscreen,
    content: renderContent
  });
}
ModalMenu.Menu = _Menu.Menu;
ModalMenu.RecursiveMenu = _RecursiveMenu.RecursiveMenu;